import { render, staticRenderFns } from "./Market.vue?vue&type=template&id=8b9e4714&scoped=true"
import script from "./Market.vue?vue&type=script&lang=js"
export * from "./Market.vue?vue&type=script&lang=js"
import style0 from "./Market.vue?vue&type=style&index=0&id=8b9e4714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9e4714",
  null
  
)

export default component.exports